import { AdvancementStatus } from '@appTypes/enums';
import type {
  CounselorMeritBadge,
  MeritBadgeCounselorProfile,
  MeritBadgeUserRequirements,
  RosterYouthMember,
} from '@appTypes/esb';
import { isAdvancementStatus } from '@shared/utils/advancementStatus';

import { ValidationOK, ValidationResult } from './slice';

function validResult(youth: RosterYouthMember): ValidationOK {
  return { valid: true, youth };
}

export function validateExistingCounselor(
  youth: RosterYouthMember,
  selectedMB: CounselorMeritBadge,
  mbcProfile: MeritBadgeCounselorProfile,
): ValidationResult {
  if (!selectedMB || !mbcProfile) return validResult(youth);

  const found = mbcProfile.youths.some(
    item =>
      item.userId === youth.userId &&
      item.meritBadgesCounseling.some(
        mb => mb.meritBadgeId === selectedMB.meritBadgeId,
      ),
  );

  if (found) {
    return {
      youth,
      valid: false,
      error: 'Already counseling this Merit Badge for youth',
    };
  }

  return validResult(youth);
}

export function validateMeritBadgeStatus(params: {
  youth: RosterYouthMember;
  requirementsByMID: Map<number, MeritBadgeUserRequirements>;
}): ValidationResult {
  const mbState = params.requirementsByMID?.get(params.youth.memberId);
  if (
    !params.requirementsByMID ||
    params.requirementsByMID.size === 0 ||
    !mbState
  ) {
    return validResult(params.youth);
  }

  const hasCompletedMB = isAdvancementStatus(
    { ...mbState, status: mbState.status || '' },
    [
      AdvancementStatus.Completed,
      AdvancementStatus.LeaderApproved,
      AdvancementStatus.CounselorApproved,
      AdvancementStatus.Awarded,
    ],
  );
  if (hasCompletedMB) {
    return {
      youth: params.youth,
      valid: false,
      error: 'Youth already completed this Merit Badge',
    };
  }
  return validResult(params.youth);
}
